import { render, staticRenderFns } from "./PricingPlanList.vue?vue&type=template&id=224091c5&scoped=true&"
import script from "./PricingPlanList.vue?vue&type=script&lang=js&"
export * from "./PricingPlanList.vue?vue&type=script&lang=js&"
import style0 from "./PricingPlanList.vue?vue&type=style&index=0&id=224091c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224091c5",
  null
  
)

export default component.exports